/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import {
  SortingState,
  IntegratedSorting,
  SearchState,
  IntegratedFiltering,
  DataTypeProvider,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  VirtualTable,
  Toolbar,
  SearchPanel,
} from '@devexpress/dx-react-grid-material-ui';
import { getRowId } from '../../common';
import { SearchTable } from '../../components';
import PageLayout from '../main/PageLayout';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { useLazyQuery, useMutation } from '@apollo/client';
import getNotifications from '../../graphql/query/getNotifications';
import { TableComponent } from '../../Shared/TableComponent';
import { eventFormatter } from '../../Shared/colorFormat';
import {
  Box,
  FormControlLabel,
  Switch,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import updatePushToken from '../../graphql/mutation/updatePushToken';
import { subscribePushToken } from '../../common/helpers';
import RefetchBox from '../../Shared/RefetchBox';

export default function Notifications({
  isRTL,
  words,
  theme,
  menuitem,
  notify,
  dispatch,
  user,
}: any) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [columns] = useState([
    { name: 'body', title: words.body },
    { name: 'eventId', title: words.appointment },
  ]);

  const { width, height } = useWindowDimensions();
  const [loadMsgs, msgsData]: any = useLazyQuery(getNotifications);

  const [updatePush] = useMutation(updatePushToken);
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleNotification = async (e: any) => {
    setLoading(true);
    const { checked } = e.target;
    dispatch({ type: 'setNotify', payload: checked });
    try {
      const pushToken = await subscribePushToken(user, checked);
      const variables = { pushToken, notify: checked };
      await updatePush({ variables });
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMsgs();
  }, []);
  useEffect(() => {
    if (msgsData?.data?.getNotifications?.data) {
      const { data } = msgsData.data.getNotifications;
      setRows(data);
    }
  }, [msgsData]);

  const refresh = () => {
    msgsData?.refetch();
  };

  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      theme={theme}
      refresh={refresh}
      loading={msgsData?.loading}
    >
      <Box>
        <Box
          display="flex"
          style={{
            position: !isMobile ? 'absolute' : 'relative',
            right: !isMobile ? 300 : 10,
            top: 60,
            alignItems: 'center',
            justifyContent: 'start',
            zIndex: 110,
          }}
        >
          <FormControlLabel
            control={
              <Tooltip
                title={
                  isRTL
                    ? notify
                      ? 'ايقاف التبيهات'
                      : 'تفعيل التنبيهات'
                    : !notify
                    ? 'Activate Notifications'
                    : 'Stop Notifications'
                }
              >
                <Switch
                  checked={notify}
                  onChange={handleNotification}
                  name="checkedA"
                  inputProps={{ 'aria-label': 'secondary checkbox' }}
                  disabled={loading}
                />
              </Tooltip>
            }
            labelPlacement="end"
            label={
              isRTL
                ? notify
                  ? 'التبيهات فعالة'
                  : 'التنبيهات متوقفة'
                : !notify
                ? 'Notifications Activated'
                : 'Notifications Stoped'
            }
          />
        </Box>
        {isMobile && (
          <Box
            style={{
              position: 'absolute',
              zIndex: 111,
              top: 60,
              left: isRTL ? 20 : undefined,
              right: isRTL ? undefined : 20,
            }}
          >
            <RefetchBox
              isRTL={isRTL}
              theme={theme}
              refresh={refresh}
              loading={msgsData?.loading}
            ></RefetchBox>
          </Box>
        )}
        <Box
          style={{
            margin: !isMobile ? 40 : 20,
            width: !isMobile ? width - 330 : width - 40,
            borderRadius: 10,
          }}
        >
          <Grid rows={rows} columns={columns} getRowId={getRowId}>
            <SortingState />
            <SearchState />
            <IntegratedSorting />
            <IntegratedFiltering />
            <VirtualTable
              height={!isMobile ? height - 180 : 'auto'}
              messages={{
                noData: isRTL ? 'لا يوجد بيانات' : 'no data',
              }}
              estimatedRowHeight={40}
              tableComponent={TableComponent}
            />
            <TableHeaderRow
              showSortingControls
              titleComponent={({ children }) => {
                return (
                  <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                    {children}
                  </Typography>
                );
              }}
            />
            <DataTypeProvider
              for={['eventId']}
              formatterComponent={(props: any) => eventFormatter({ ...props })}
            ></DataTypeProvider>
            <Toolbar />
            <SearchPanel
              inputComponent={(props: any) => {
                return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
              }}
            />
          </Grid>
        </Box>
      </Box>
    </PageLayout>
  );
}
